import { Component, Input } from "@angular/core";
import { CachedFile } from "../../../shared/types/sync-action";

@Component({
	selector: "ic-cached-file-item",
	templateUrl: "./cached-file-item.component.html",
	styleUrls: ["./cached-file-item.component.scss"],
	standalone: false,
})
export class CachedFileItemComponent {
	// @ts-expect-error TS2564
	@Input() cachedFile: CachedFile;
}
